module.exports = __webpack_public_path__ + "img/alert.87984d86.svg";